import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TopBar } from "../../app/TopBar";
import { PageFooter } from "../../app/PageFooter";
import { useAppUser } from "../../app/AppUserContext";
import { ClientsTab } from "./ClientsTab";
import { PriceNominationsTab } from "./PriceNominationsTab";
import { SpotNominationsTab } from "./SpotNominationsTab";
import { TdsDetailsTab } from "./TdsDetailsTab";
import { PATHS } from "../../app/paths";

const MODES = [
  { key: "clients", label: "Clients", icon: "storefront" },
  { key: "nominations", label: "Price Nominations", icon: "description" },
  { key: "spot", label: "Spot Nominations", icon: "bolt" },
  { key: "tds", label: "TDS Details", icon: "lab_profile" },
] as const;
type Mode = (typeof MODES)[number]["key"];

export function DataView() {
  const navigate = useNavigate();
  const { appRole } = useAppUser();
  const [mode, setMode] = useState<Mode>("clients");

  return (
    <>
      <TopBar title="Resin8 Data View">
        <button className="btn ghost" onClick={() => navigate(PATHS.intake)}>
          <span className="material-symbols-sharp">upload_file</span>Data Intake Tool
        </button>
        {appRole === "Admin" && (
          <button className="btn ghost" onClick={() => navigate(PATHS.adminUsers)}>
            <span className="material-symbols-sharp">admin_panel_settings</span>Users
          </button>
        )}
      </TopBar>

      <nav className="tabs" role="tablist" aria-label="Data view">
        {MODES.map((m) => (
          <button
            key={m.key}
            className="tab"
            role="tab"
            aria-selected={mode === m.key}
            aria-controls={`dataview-${m.key}`}
            onClick={() => setMode(m.key)}
          >
            <span className="material-symbols-sharp">{m.icon}</span>
            {m.label}
          </button>
        ))}
      </nav>

      <main>
        {mode === "clients" && <ClientsTab />}
        {mode === "nominations" && <PriceNominationsTab />}
        {mode === "spot" && <SpotNominationsTab />}
        {mode === "tds" && <TdsDetailsTab />}
      </main>

      <PageFooter />
    </>
  );
}
